(function () {
  'use strict';

  function initProductAddons() {
    var blocks = document.querySelectorAll('.product-addons');
    blocks.forEach(function (block) {
      if (block.dataset.addonInit) return;
      block.dataset.addonInit = '1';
      setupBlock(block);
    });
    initCustomProductTag();
  }

  function initCustomProductTag() {
    var blocks = document.querySelectorAll('.product-custom-tag');
    blocks.forEach(function (block) {
      if (block.dataset.cptInit) return;
      block.dataset.cptInit = '1';
      setupCustomProductTag(block);
    });
  }

  function setupCustomProductTag(block) {
    var select = block.querySelector('.product-custom-tag__select');
    if (!select) return;
    select.addEventListener('change', function () {
      updateCustomTagVariants(block);
      syncCustomTagInputs(block);
    });
    block.addEventListener('change', function (e) {
      if (e.target.classList.contains('product-custom-tag__variant-select')) {
        syncCustomTagInputs(block);
      }
    });
    updateCustomTagVariants(block);
    syncCustomTagInputs(block);
  }

  function updateCustomTagVariants(block) {
    var select = block.querySelector('.product-custom-tag__select');
    var variantsWrap = block.querySelector('.product-custom-tag__variants-wrap');
    var variantSelect = block.querySelector('.product-custom-tag__variant-select');
    if (!select || !variantsWrap || !variantSelect) return;

    var selectedOption = select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
    var variantCount = parseInt(selectedOption ? (selectedOption.dataset.variantCount || '0') : '0', 10);
    var variantsData = selectedOption ? (selectedOption.dataset.variants || '') : '';
    var hidePrice = block.dataset.hidePrice === 'true';
    var filterRaw = block.dataset.variantFilter || '';
    var filters = filterRaw.split(',').map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);

    if (!selectedOption || !selectedOption.value || !variantsData) {
      variantsWrap.hidden = true;
      variantSelect.innerHTML = '';
      return;
    }

    if (variantCount <= 1 && !filters.length) {
      variantsWrap.hidden = true;
      variantSelect.innerHTML = '';
      return;
    }

    var variants;
    try { variants = JSON.parse(variantsData); } catch (e) {
      variantsWrap.hidden = true;
      return;
    }

    if (filters.length) {
      variants = variants.filter(function (v) {
        var opts = (v.o || []).map(function (o) { return String(o).toLowerCase(); });
        return filters.some(function (f) { return opts.indexOf(f) !== -1; });
      });
    }

    if (!variants.length) {
      variantsWrap.hidden = true;
      variantSelect.innerHTML = '';
      return;
    }

    variantSelect.innerHTML = variants.map(function (v) {
      var price = (!hidePrice && v.pm) ? ' — + ' + v.pm : '';
      var soldOut = v.a ? '' : ' (Sold out)';
      var disabled = v.a ? '' : ' disabled';
      return '<option value="' + v.id + '"' + disabled + '>' + escapeHtml(v.t) + price + soldOut + '</option>';
    }).join('');

    variantsWrap.hidden = false;
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function syncCustomTagInputs(block) {
    var select = block.querySelector('.product-custom-tag__select');
    var variantsWrap = block.querySelector('.product-custom-tag__variants-wrap');
    var variantSelect = block.querySelector('.product-custom-tag__variant-select');

    var id = '';
    if (variantsWrap && !variantsWrap.hidden && variantSelect && variantSelect.value) {
      id = variantSelect.value;
    } else if (select && select.value) {
      id = select.value;
    }
    block.dataset.selectedAddons = id;
  }

  function setupBlock(block) {
    var blockId = block.id;
    var maxSelections = parseInt(block.dataset.maxSelections || '0', 10);
    var limitMsg = document.getElementById('addon-limit-msg-' + block.dataset.blockId);

    // --- Tabs ---
    var tabs = block.querySelectorAll('.product-addons__tab');
    var cards = block.querySelectorAll('.product-addons__card');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); });
        tab.classList.add('active');
        var target = tab.dataset.tab;
        cards.forEach(function (card) {
          if (target === 'all' || card.dataset.collection === target) {
            card.classList.remove('hidden');
          } else {
            card.classList.add('hidden');
          }
        });
        updateArrows(block);
      });
    });

    // --- Card Selection ---
    cards.forEach(function (card) {
      if (card.dataset.available === 'false') {
        card.classList.add('unavailable');
        return;
      }
      card.addEventListener('click', function (e) {
        // Ignore clicks on the info button
        if (e.target.classList.contains('product-addons__info-btn')) return;

        var isSelected = card.classList.contains('selected');

        if (!isSelected && maxSelections > 0) {
          var currentSelected = block.querySelectorAll('.product-addons__card.selected').length;
          if (currentSelected >= maxSelections) {
            if (limitMsg) {
              limitMsg.removeAttribute('hidden');
              setTimeout(function () { limitMsg.setAttribute('hidden', ''); }, 2500);
            }
            return;
          }
        }

        card.classList.toggle('selected');
        syncInputs(block);
      });
    });

    // --- Carousel Arrows ---
    var carousel = block.querySelector('.product-addons__carousel');
    var prevBtn = block.querySelector('.product-addons__arrow--prev');
    var nextBtn = block.querySelector('.product-addons__arrow--next');

    if (carousel && prevBtn && nextBtn) {
      prevBtn.addEventListener('click', function () {
        carousel.scrollBy({ left: -170, behavior: 'smooth' });
      });
      nextBtn.addEventListener('click', function () {
        carousel.scrollBy({ left: 170, behavior: 'smooth' });
      });
      carousel.addEventListener('scroll', function () {
        updateArrows(block);
      });
      updateArrows(block);
    }

    // --- Info Modal ---
    block.querySelectorAll('.product-addons__info-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var targetId = btn.dataset.infoTarget;
        var modalContent = document.getElementById(targetId);
        if (!modalContent) return;
        openModal(modalContent.innerHTML);
      });
    });
  }

  function updateArrows(block) {
    var carousel = block.querySelector('.product-addons__carousel');
    var prevBtn = block.querySelector('.product-addons__arrow--prev');
    var nextBtn = block.querySelector('.product-addons__arrow--next');
    if (!carousel || !prevBtn || !nextBtn) return;

    var atStart = carousel.scrollLeft <= 4;
    var atEnd = carousel.scrollLeft + carousel.clientWidth >= carousel.scrollWidth - 4;

    prevBtn.classList.toggle('hidden', atStart);
    nextBtn.classList.toggle('hidden', atEnd);
  }

  function syncInputs(block) {
    var selectedIds = Array.from(block.querySelectorAll('.product-addons__card.selected'))
      .map(function (card) { return card.dataset.variantId; })
      .filter(Boolean);
    block.dataset.selectedAddons = selectedIds.join(',');
  }

  // --- Modal ---
  var activeModal = null;

  function openModal(innerHtml) {
    closeModal();
    var overlay = document.createElement('div');
    overlay.className = 'product-addons__modal-overlay';
    overlay.innerHTML = '<div class="product-addons__modal-inner">' +
      '<button class="product-addons__modal-close" aria-label="Close">&times;</button>' +
      innerHtml +
      '</div>';

    overlay.querySelector('.product-addons__modal-close').addEventListener('click', closeModal);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) closeModal();
    });

    document.body.appendChild(overlay);
    activeModal = overlay;

    document.addEventListener('keydown', onEscape);
  }

  function closeModal() {
    if (activeModal) {
      activeModal.remove();
      activeModal = null;
    }
    document.removeEventListener('keydown', onEscape);
  }

  function onEscape(e) {
    if (e.key === 'Escape') closeModal();
  }

  // --- Cart button intercept (capture phase — runs before jQuery's delegated handler) ---
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js_add_to_cart_button');
    if (!btn) return;

    // Collect selected add-on variant IDs across all blocks on the page
    var addonItems = [];
    document.querySelectorAll('.product-addons, .product-custom-tag').forEach(function (block) {
      var ids = block.dataset.selectedAddons;
      if (!ids) return;
      ids.split(',').forEach(function (variantId) {
        variantId = variantId.trim();
        if (variantId) {
          addonItems.push({ id: parseInt(variantId, 10), quantity: 1 });
        }
      });
    });

    // No add-ons selected — let the theme handle cart normally
    if (!addonItems.length) return;

    // Add-ons selected — stop the theme's handler and take over
    e.stopImmediatePropagation();
    e.preventDefault();

    var form = btn.closest('form');
    if (!form) return;

    var variantInput = form.querySelector('[name="id"]');
    if (!variantInput) return;

    var qtyInput = form.querySelector('[name="quantity"]');
    var items = [
      { id: parseInt(variantInput.value, 10), quantity: qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1 }
    ].concat(addonItems);

    btn.classList.add('ajax_loading');
    btn.setAttribute('disabled', 'disabled');

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: 'minicart',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (response) {
        btn.classList.remove('ajax_loading');
        btn.removeAttribute('disabled');

        if (response && response.status) {
          console.error('[product-addons] Cart add failed:', response.description);
          if (response.description) alert(response.description);
          return;
        }

        // Update button text briefly
        var textEl = btn.querySelector('.text');
        var originalText = textEl ? textEl.innerHTML : '';
        if (textEl) textEl.textContent = 'Added';
        setTimeout(function () {
          if (textEl && !btn.disabled) textEl.innerHTML = originalText;
        }, 1000);

        // Tell the theme to update minicart HTML + counts (passing sections in response)
        var eventDetail = { response: response };
        if (window.jQuery) {
          jQuery('body').trigger('ajax:addToCart', [eventDetail]);
        }
        document.body.dispatchEvent(new CustomEvent('ajax:addToCart', {
          bubbles: true,
          detail: eventDetail
        }));

        // Open the cart drawer — same mechanism the theme uses
        if (window.jQuery) {
          var $html = jQuery('html');
          if (!$html.hasClass('pside_opened')) {
            jQuery('.push_side[data-id="#js_cart_popup"]').trigger('click');
          }
        }
      })
      .catch(function (err) {
        btn.classList.remove('ajax_loading');
        btn.removeAttribute('disabled');
        console.error('[product-addons] Cart add error:', err);
      });
  }, true /* capture phase */);

  // Init on DOMContentLoaded and after dynamic re-renders
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductAddons);
  } else {
    initProductAddons();
  }

  // Re-init if theme re-renders blocks (e.g. variant change)
  document.body.addEventListener('BoughtTogetherUpdated', initProductAddons);
})();
